// Remember to add a new body here and in bodies.js
// Keep these in selectability order: https://www.mariowiki.com/Mario_Kart_8_Deluxe#Available_parts
export const BODIES_BY_TYPE = {
  'Karts': [
    'Standard Kart',
    'Pipe Frame',
    'Mach 8',
    'Steel Driver',
    'Cat Cruiser',
    'Circuit Special',
    'Tri-Speeder',
    'Badwagon',
    'Prancer',
    'Biddybuggy (Buggybud)',
    'Landship',
    'Sneeker (Bounder)',
    'Sports Coupe (Sports Coupé)',
    'Gold Standard (Gold Kart)',
    'GLA',
    'W 25 Silver Arrow',
    '300 SL Roadster',
    'Blue Falcon',
    'Tanooki Kart',
    'B Dasher',
    'Streetle',
    'P-Wing',
    'Koopa Clown'
  ],
  'Standard Bikes': [
    'Standard Bike',
    'The Duke',
    'Flame Rider',
    'Varmint',
    'Mr. Scooty (Mr Scooty)',
    'Master Cycle Zero',
    'City Tripper'
  ],
  'Sport Bikes': [
    'Comet',
    'Sport Bike',
    'Jet Bike',
    'Yoshi Bike',
    'Master Cycle'
  ],
  'ATVs': [
    'Standard ATV (Standard Quad)',
    'Wild Wiggler',
    'Teddy Buggy',
    'Bone Rattler',
    'Splat Buggy',
    'Inkstriker'
  ]
};

export const BODY_TYPES = Object.keys(BODIES_BY_TYPE);
